import React, { Component, Fragment, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../global';
import { connect } from 'react-redux';
// import { documentTypeFilter } from '../actions';
import SideBarWelcome from './side-bar-welcome';
import MyProfileIcons from './my-profile-icons';

class MyAccountSideBar extends Component {
	constructor( props ) {
		super( props );
		this.state = {
			expandedSections: {},
			isMobile        : false,
			showSideBar     : false,
			activeItem      : this.props.section || !this.props.isMobile
			                  ? 'profile'
			                  : ''

		};

		// Bind methods to this
		this.toggleSection = this.toggleSection.bind( this );
		this.handleMobileSidebarToggle = this.handleMobileSidebarToggle.bind( this );
		this.toggleAccountItem = this.toggleAccountItem.bind( this );
	}

	handleResize() {
		//IF UPDATING SIZE HERE, UPDATE IN _CATEGORY-ARCHIVE.SCSS AS WELL.
		const isMobile = window.innerWidth <= 992;

		if ( !isMobile && this.state.showFilters ) {
			this.setState( { showFilters: false } );
			document.body.classList.remove( 'no-scroll' );
		} else {
			this.setState( { isMobile } );
		}
	}

	toggleAccountItem( index ) {
		this.setState( { activeItem: index } );
	}

	componentDidMount() {
		this.handleResize();
		window.addEventListener( 'resize', this.handleResize.bind( this ) );

		// Add event listeners to the mobile sidebar toggle buttons
		const mobileSidebarButtons = document.querySelectorAll( '#mobile-sidebar-options, .btn-show-categories' );
		mobileSidebarButtons.forEach( button => {
			button.addEventListener( 'click', this.handleMobileSidebarToggle );
		} );
		//For scroll 
		this.handleScroll = this.handleScroll.bind( this );
		window.addEventListener( 'scroll', this.handleScroll );
		this.sidebarRef = React.createRef();
		this.handleScroll();
	}

	componentWillUnmount() {
		window.removeEventListener( 'resize', this.handleResize.bind( this ) );

		// Remove event listeners from the mobile sidebar toggle buttons
		const mobileSidebarButtons = document.querySelectorAll( '#mobile-sidebar-options, .btn-show-categories' );
		mobileSidebarButtons.forEach( button => {
			button.removeEventListener( 'click', this.handleMobileSidebarToggle );
		} );
		window.removeEventListener( 'scroll', this.handleScroll );

	}

	handleMobileSidebarToggle() {
		this.setState( prevState => ({
			showSideBar: !prevState.showSideBar
		}
		), () => {
			if ( this.state.showSideBar && this.sidebarRef.current ) {
				this.sidebarRef.current.style.bottom = 'auto';
				this.sidebarRef.current.style.top = '0';
			}
		} );
	}

	handleScroll() {
		// const sidebar = this.sidebarRef.current;
		// const footer = document.querySelector('.site-footer');
		// const loginBlock = document.querySelector('.login-block-common');
		// const header = document.querySelector('.site-header');
		// if (!sidebar || !footer || !header) return;

		// const sidebarRect = sidebar.getBoundingClientRect();
		// const footerRect = footer.getBoundingClientRect();
		// const headerRect = header.getBoundingClientRect();
		// const windowHeight = window.innerHeight;
		// const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		// if (scrollTop <= headerRect.height) {
		//   // We've reached the top of the page (minus header height)
		//   sidebar.style.bottom = 'auto';
		//   sidebar.style.top = 'auto';
		// } else if (!header.classList.contains('fixed-header')) {
		//   sidebar.style.bottom = '0';
		//   sidebar.style.top = 'auto';
		// } else if (loginBlock && window.getComputedStyle(loginBlock).display === 'block') {
		//   sidebar.style.bottom = 'auto';
		// } else if (footerRect.top <= windowHeight) {
		//   const overlap = windowHeight - footerRect.top;
		//   sidebar.style.bottom = `${overlap}px`;
		//   sidebar.style.top = 'auto';
		// } else {
		//   sidebar.style.position = 'fixed';
		//   sidebar.style.top = 'initial';
		//   sidebar.style.bottom = 'auto';
		// }

		// if (this.state.showSideBar) {
		//   sidebar.style.bottom = 'auto';
		//   sidebar.style.top = '0';
		// }
	}

	toggleSection( index ) {
		this.setState( function( prevState ) {
			return {
				expandedSections: {
					...prevState.expandedSections,
					[ index ]: !prevState.expandedSections[ index ]
				}
			};
		} );
	}

	renderAccountItems() {
		const account_info = getMyAccountObj();
		const accountItems = [
			{
				name   : 'My Profile',
				icon   : (<MyProfileIcons icon="profile"
				                          active={ this.props.section === 'profile' || (!this.props.isMobile && this.props.section === ''
				                          ) }/>
				),
				link   : '/my-account?section=profile',
				slug   : 'profile',
				active : this.props.section === 'profile' || (!this.props.isMobile && this.props.section === ''
				)
			}, {
				name   : 'Change Password',
				icon   : (<MyProfileIcons icon="password"
				                          active={ this.props.section === 'password' }/>
				),
				link   : '/my-account?section=password',
				slug   : 'password',
				active : this.props.section === 'password'
			}, {
				name   : 'Email Preferences',
				icon   : (<MyProfileIcons icon="email"
				                          active={ this.props.section === 'email-preferences' }/>
				),
				link   : '/my-account?section=email-preferences',
				slug   : 'email-preferences',
				active : this.props.section === 'email-preferences'
			}, {
				name  : 'ISDA Library',
				active: this.props.section === 'isda-library',
				icon  : (<MyProfileIcons icon="isda-library"
				                         active={ this.props.section === 'isda-library' }/>
				),
				link  : '/my-account?section=isda-library',
				slug  : 'isda-library'
			}, {
				name  : 'Bookmarks',
				active: this.props.section === 'bookmarks',
				icon  : (<MyProfileIcons icon="bookmarks"
				                         active={ this.props.section === 'bookmarks' }/>
				),
				link  : '/my-account?section=bookmarks',
				slug  : 'bookmarks'
			}, {
				name  : 'Orders & Invoices',
				icon  : (<MyProfileIcons icon="orders-and-invoices"
				                         active={ this.props.section === 'orders-and-invoices' }/>
				),
				link  : '/my-account?section=orders-and-invoices',
				slug  : 'orders-and-invoices',
				active: this.props.section === 'orders-and-invoices'
			}
		];

		// Add Invoice History if it exists in account_info
		if ( account_info && (account_info.invoice_history && account_info.invoice_history.length > 0 || account_info.subscriptions_and_dues && account_info.subscriptions_and_dues.length > 0
		) ) {
			accountItems.push( {
				                   name  : 'Subscriptions & Dues',
				                   active: this.props.section === 'subscriptions-and-dues',
				                   icon  : (<MyProfileIcons
						                   icon="subscriptions-and-dues"
						                   active={ this.props.section === 'subscriptions-and-dues' }/>
				                   ),
				                   link  : '/my-account?section=subscriptions-and-dues',
				                   slug  : 'subscriptions-and-dues'
			                   } );
		}

		return (<div>
				{ accountItems.map( ( item, index ) => (<div key={ index }
				                                             className={ 'account-item' + (item.active
				                                                                           ? ' active'
				                                                                           : ''
				                                             ) }>
						{ item.icon }
						<Link to={ item.link }
						      onClick={ () => this.toggleAccountItem( item.slug ) }
						      className={ `${ this.props.section === item.slug
						                      ? 'active'
						                      : '' }` }>{ item.name } { this.props.isMobile &&
						                                                <i className="fa fa-chevron-right"></i> }</Link>

					</div>
				) ) }
			</div>
		);
	}

	render() {
		const bookSections = [];

		return (<div
				className={ `col-lg-3 side-bar side-bar-container my-account-side-bar ${ this.state.showSideBar
				                                                                         ? 'active'
				                                                                         : '' }` }
				ref={ this.sidebarRef }>
				<div className="side-bar-desktop">
					<div
						className="sidebar-heading-container center my-account">
						<SideBarWelcome/>
					</div>
					<hr className={ 'section-divider' }/>
					{ this.renderAccountItems() }
				</div>
				{ this.state.showSideBar && (<button className="done-button"
				                                     onClick={ this.handleMobileSidebarToggle }>Done</button>
				) }
			</div>
		);
	}

}

function mapStateToProps( {} ) {
	return {};
};

export default connect( mapStateToProps, {} )( MyAccountSideBar );